import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInstitutions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/institution', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStates(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/address/states', params)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    searchCpf(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-cache/search-cpf', { params })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    searchCnpj(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-cache/search-cnpj', { params })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    searchCrm(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-cache/search-crm', { params })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    deleteCpfCnpj(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-cache/cpf-cnpj/${id}`)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    deleteCrm(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/admin-cache/crm/${id}`)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
  },
}
